<template>
  <div class="w-100">
    <h5 class="mt-3 mb-3">Betrag wählen</h5>
    <b-form-input type="range" 
      id="range-1" 
      v-model="getSelectedItem.count" 
      variant=""
      class="custom-range" 
      step="10" 
      :min="getSelectedItem.minimumPrice" 
      :max="getSelectedItem.maximumPrice"
      style="border: none;" />
    <h5 class="mt-2 text-uppercase">Betrag: € {{ getSelectedItem.count }}</h5>
  </div>
</template>

<script>
export default {
  name: "ShopVoucherServiceVariablePrice",
  props: ["getSelectedItemId"],
  methods: {
    getTotalSum: function() {
      return this.getSelectedItem.count;
    },
    getCachedItem() {
      return this.$store.getters.getCachedItemById(this.getSelectedItemId);
    },
    checkValue() {
      if (this.getSelectedItem.count >= this.getSelectedItem.maximumPrice) {
        this.getSelectedItem.count = this.getSelectedItem.maximumPrice;
      }

      if (this.getSelectedItem.count <= this.getSelectedItem.minimumPrice) {
        this.getSelectedItem.count = this.getSelectedItem.minimumPrice;
      }
    }
  },
  computed: {
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getLanguageItem: function() {
      return this.$store.getters.getLanguageStrings;
    },
    getServices() {
     // console.log(this.getSelectedItem.type);
      return this.getSelectedItem.fixedPrice;
    },
    getSelectedItem() {
      return this.getCachedItem();
    }
  },
  beforeMount() {
    this.getSelectedItem.count = this.getSelectedItem.minimumPrice;
  }
};
</script>
